"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPaymentTermsOfService = void 0;

var _Http = require("./Http");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var resource = "portal";
var resourceVersion = "1";
var baseUrl = "".concat(resource, "/").concat(resourceVersion, "/");
/**
 * Retrieve specified terms of service
 *
 * @param {number} termsTypeId specifies which terms of service to retrieve
 * @returns {object} object containing termsHTML and lastUpdated date
 */

var getTermsOfService = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(termsTypeId) {
    var response;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, _Http.get)(baseUrl + "termsOfService/terms/".concat(termsTypeId));

          case 2:
            response = _context.sent;
            return _context.abrupt("return", response.data);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getTermsOfService(_x) {
    return _ref.apply(this, arguments);
  };
}();
/**
 * Retrieve online payment terms of service
 *
 * @returns {object} object containing termsHTML and lastUpdated date
 */


var getPaymentTermsOfService = function getPaymentTermsOfService() {
  return getTermsOfService(1); //1 - Online Payment
};

exports.getPaymentTermsOfService = getPaymentTermsOfService;